<template>
  <div class="app-container">
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{
        backgroundColor: '#0E59CB',
        color: '#fff',
      }"
      :default-sort="{ prop: 'date', order: 'descending' }"
      ref="singleTable"
      :highlight-selection-row="false"
      :row-class-name="tableRowClassName"
    >
      <el-table-column prop="date" label="维修单号" sortable> </el-table-column>
      <el-table-column prop="name" label="项目名称" sortable> </el-table-column>
      <el-table-column prop="tplx" label="投票类型" sortable> </el-table-column>
      <el-table-column prop="tpjg" sortable label="投票结果"> </el-table-column>
    </el-table>
    <Pagination
      style="margin-top: 10px"
      v-show="query.total > 0"
      :total="query.total"
      :limit.sync="query.pageSize"
      :page.sync="query.pageNum"
      round="false"
      layout="total, sizes, prev, pager, next, jumper"
      @pagination="initPage"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      query: {
        total: 10,
        pageNum: 1,
        pageSize: 6,
      },
    };
  },
  mounted() {
    this.query.total = this.tableData.length;
  },
  methods: {
    initPage() {},
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}
::v-deep.el-table tbody tr:hover > td {
  background-color: unset !important;
}
::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}
::v-deep .el-table__empty-text {
  color: #fff;
}
</style>
